import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { productsListingApi } from '@apis/seller-center/products.js';
import { Toast } from '@common-web';
import { getErrorString } from '@utils/utils';
import { store } from '../../../store';

const initialState = {
  products: [],
  statuses: [],
  productExternalIDs: [],
  productUserExternalIDs: [],
  dispositions: [],
  pagination: null,
  success: false,
  loading: false,
  aggregations: null,
};

export const fetchProductListing = createAsyncThunk('products/listing', async (params = '') => {
  try {
    const products = await productsListingApi(params);
    const state = store.getState();
    const storeExternalID = state?.userData?.userInfo?.userProfile?.store?.external_id;
    return { ...products, user_external_id: storeExternalID };
  } catch (err) {
    Toast.error(getErrorString(err));
  }
});

const ProductsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    deleteProductAction: (state, action) => {
      if (action.payload.id) {
        state.products = state.products?.filter((product) => product?.id !== action?.payload?.id);
      }
    },
    editProductAction: (state, action) => {
      if (action.payload.id) {
        const index = state.products.findIndex((e) => e.id === action.payload.id);
        state.products[index] = { ...state.products[index], ...action.payload };
      }
    },
    filterDispositions: (state, action) => {
      if (action.payload?.statusIndex !== -1) {
        state.dispositions = state.statuses?.[action.payload.statusIndex]?.dispositions ?? [];
      } else {
        state.dispositions = state.statuses?.flatMap((status) => status.dispositions) ?? [];
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchProductListing.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProductListing.fulfilled, (state, action) => {
        const ids = [];
        const userIds = [];
        action?.payload?.products?.map((item) => {
          if (item?.external_id) {
            ids?.push(item?.external_id);
          }
          if (action?.payload?.user_external_id) {
            userIds?.push(action?.payload?.user_external_id);
          }
        });

        state.productExternalIDs = ids;
        state.productUserExternalIDs = userIds;
        state.products = action?.payload?.products;
        state.pagination = action?.payload?.pagination;
        state.aggregations = action?.payload?.aggregations;
        state.loading = false;
        state.statuses = action?.payload?.statuses_and_dispositions ?? [];
      })
      .addCase(fetchProductListing.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { deleteProductAction, editProductAction, filterDispositions } = ProductsSlice.actions;
export default ProductsSlice.reducer;
